import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessagingService } from 'src/app/core/messaging/messaging.service';
import { TranslationService } from 'src/app/core/translation/translation.service';
import { ProjectStreamService } from 'src/app/shared/common/current-project/project-stream.service';
import { TCFileService } from 'src/app/shared/common/files/TCFile.service';

@Component({
    selector: 'edit-job-tags',
    templateUrl: './edit-job-tags.component.html'
})
export class EditJobTagsComponent implements OnInit {
    private _jobTags: string[] = [];

    @Input()
    get jobTags(): string[] {
        return this._jobTags;
    }
    set jobTags(tags: string[]) {
        this._jobTags = Array.isArray(tags) ? [...tags] : [];
    }

    @Output() jobTagsChange = new EventEmitter<string[]>();

    placeholder: string = '';
    allTags: string[] = [];

    constructor(
        private messaging: MessagingService,
        private translate: TranslationService,
        private tcFileService: TCFileService,
        private projectStream: ProjectStreamService
    ) {}

    ngOnInit(): void {
        this.fetchConnectTags();
        this.placeholder = this.translate.instant('TC.Common.SearchEllipsis');
    }

    private async fetchConnectTags() {
        this.allTags = await this.projectStream.getProjectTags().then(tags => tags.map(tag => tag.label));
    }

    addTag(tag: string): void {
        let newValue = tag.trim();
        if (newValue === '') return;
        if (newValue.length > 40) {
            this.messaging.showError('Tag length should not exceed 40 characters');
            return;
        }
        const tagExists = this.allTags.some(tag => tag.toLowerCase() === newValue.toLowerCase());
        if (!tagExists) {
            this.tcFileService
                .createTag(this.projectStream.currentProject.id, newValue, newValue)
                .then(() => {
                    this._jobTags = [...this._jobTags, newValue];
                    this.allTags = [...this.allTags, newValue];
                    this.jobTagsChange.emit(this._jobTags);
                })
                .catch(() => {
                    this.messaging.showError(this.translate.instant('Survey.SurveyEditPanel.ErrorPatchMessage'));
                });
            return;
        }
        this._jobTags = [...this._jobTags, newValue];
        this.jobTagsChange.emit(this._jobTags);
    }

    removeTag(tag: string): void {
        const index = this._jobTags.indexOf(tag);
        if (index > -1) {
            this._jobTags.splice(index, 1);
        }
        this.jobTagsChange.emit(this._jobTags);
    }
}
